<template>
    <div>
        <!-- 历史消息 -->
        <el-table :data="detail.notice">
            <el-table-column label="消息标题" prop="title"></el-table-column>
            <el-table-column label="消息类型" prop="noticeType"></el-table-column>
            <el-table-column label="发送人" prop="createUser"></el-table-column>
            <el-table-column label="接收人" prop="toUser"></el-table-column>
            <el-table-column label="发送时间" prop="createTime"></el-table-column>
            <el-table-column label="发送状态" prop="status"></el-table-column>
            <el-table-column label="备注" prop="comment"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
